/**
 * Date helpers for talking to the backend.
 *
 * The backend serializes UTC-aware timestamps, so the JSON now carries a
 * timezone marker (`"2026-05-06T11:51:21.676000Z"`) and the browser's
 * `new Date(...)` parses it correctly. (This is enforced by `tz_aware=True`
 * on the Mongo/Motor client - see backend `src/database.py`.)
 *
 * `parseUtcDate` remains the canonical way to parse a backend timestamp:
 * prefer it over a bare `new Date(...)` so any legacy/naive string (no tz
 * marker) is still treated as UTC rather than local time. Without it, a
 * naive string drifts by the user's UTC offset (e.g. "6 hours ago" for a
 * row created right now in IST). Strings that already carry `Z` or an
 * offset (`+05:30`) pass through unchanged; a `Date` is returned as-is.
 */
const HAS_TZ_RE = /(?:Z|[+-]\d{2}:?\d{2})$/i;

export function parseUtcDate(input: string | Date): Date {
  if (input instanceof Date) return input;
  if (HAS_TZ_RE.test(input)) return new Date(input);
  return new Date(`${input}Z`);
}
